export function Main({ className = '', ...props }) {
  return (
    <main
      className={`w-full h-full text-center bg-gray-0 py-8 ${className}`}
      {...props}
    />
  );
}
